// CSS defines 1in as 96 CSS pixels. Browsers do not expose the display's
// physical dimensions, so this is a nominal size and may need calibration.
export const CSS_PIXELS_PER_MM = 96 / 25.4;
